import React from "react";
import { Button, Row, Col, Form } from "react-bootstrap";
import { FaCompressAlt, FaExpandAlt, FaTrash, FaPlus } from "react-icons/fa";

const Fields = ({ schema, data, set_data }) => {
  if (!data.language) set_data({ ...data, language: "fa" });

  const renderInputs = () =>
    schema.map(input => {
      const Component = inputs(input.name);
      if (Component)
        return (
          <Component
            key={input.name}
            {...input}
            data={data}
            set_data={set_data}
          />
        );
      else return null;
    });

  return (
    <>
      <Row className="text-right">
        <Col md={12}>
          <Form.Group>
            <Form.Label>زبان</Form.Label>
            <Form.Control
              onChange={e => {
                const new_data = { ...data };
                new_data.language = e.target.value;
                set_data(new_data);
              }}
              as="select"
              defaultValue={data.language}>
              <option value="fa">فارسی</option>
              <option value="en">انگلیسی</option>
              <option value="ar">عربی</option>
            </Form.Control>
          </Form.Group>
        </Col>
        <Col md={12}>
          <Form.Group>
            <Form.Label>عنوان</Form.Label>
            <Form.Control
              onChange={e => {
                const new_data = { ...data };
                new_data.title = e.target.value;
                set_data(new_data);
              }}
              defaultValue={data.title}
              type="text"
            />
          </Form.Group>
        </Col>
      </Row>
      {renderInputs()}
    </>
  );
};
const inputs = type => {
  switch (type) {
    case "creators":
      return ({ positions, title, data, set_data }) => {
        const author = data.author || [
          {
            type: "fullname",
            given: "",
            family: "",
            position: positions[0].name,
          },
        ];
        const addCreator = () => {
          author.push({
            type: "fullname",
            given: "",
            family: "",
            position: positions[0].name,
          });
          set_data({ ...data, author });
        };
        const remove = index => {
          author.splice(index, 1);
          set_data({ ...data, author });
        };
        const changeType = (creator, index) => {
          if (creator.type === "fullname") {
            author[index] = {
              type: "literal",
              literal: "",
            };
          }
          if (creator.type === "literal") {
            author[index] = {
              type: "fullname",
              given: "",
              family: "",
            };
          }
          set_data({ ...data, author });
        };
        const renderInputs = (creator, index) => {
          if (creator.type === "fullname") {
            return (
              <>
                <Col style={{ paddingLeft: 2, paddingRight: 2 }} md={3}>
                  <Form.Group>
                    <Form.Control
                      placeholder="نام"
                      type="text"
                      value={creator.given === "NuLL" ? "" : creator.given}
                      onChange={e => {
                        author[index].given = e.target.value;
                        set_data({ ...data, author });
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col style={{ paddingLeft: 2, paddingRight: 2 }} md={3}>
                  <Form.Group>
                    <Form.Control
                      placeholder="نام خانوادگی"
                      type="text"
                      value={creator.family === "NuLL" ? "" : creator.family}
                      onChange={e => {
                        author[index].family = e.target.value;
                        set_data({ ...data, author });
                      }}
                    />
                  </Form.Group>
                </Col>
              </>
            );
          } else {
            return (
              <>
                <Col style={{ paddingLeft: 2, paddingRight: 2 }} md={6}>
                  <Form.Group>
                    <Form.Control
                      placeholder="عنوان"
                      type="text"
                      value={creator.literal === "NuLL" ? "" : creator.literal}
                      onChange={e => {
                        author[index].literal = e.target.value;
                        set_data({ ...data, author });
                      }}
                    />
                  </Form.Group>
                </Col>
              </>
            );
          }
        };
        return (
          <>
            <Row>
              <Col
                style={{
                  direction: "rtl",
                  textAlign: "right",
                  marginBottom: 5,
                }}>
                {title.fa}
              </Col>
            </Row>
            {author.map((creator, index) => {
              let actions = (
                <>
                  <Col style={{ paddingLeft: 2, paddingRight: 2 }} md={1}>
                    <Button
                      block
                      variant="outline-info"
                      onClick={() => {
                        changeType(creator, index);
                      }}>
                      {creator.type === "fullname" ? (
                        <FaCompressAlt />
                      ) : (
                        <FaExpandAlt />
                      )}
                    </Button>
                  </Col>
                  <Col style={{ paddingRight: 2 }} md={1}>
                    <Button
                      onClick={() => {
                        remove(index);
                      }}
                      block
                      variant="outline-danger">
                      <FaTrash />
                    </Button>
                  </Col>
                </>
              );
              if (index === author.length - 1)
                actions = (
                  <>
                    <Col style={{ paddingLeft: 2, paddingRight: 2 }} md={1}>
                      <Button
                        block
                        variant="outline-info"
                        onClick={() => {
                          changeType(creator, index);
                        }}>
                        {creator.type === "fullname" ? (
                          <FaCompressAlt />
                        ) : (
                          <FaExpandAlt />
                        )}
                      </Button>
                    </Col>
                    <Col style={{ paddingRight: 2 }} md={1}>
                      <Button
                        onClick={addCreator}
                        block
                        variant="outline-success">
                        <FaPlus />
                      </Button>
                    </Col>
                  </>
                );
              return (
                <Row key={index}>
                  <Col style={{ paddingLeft: 2 }} md={4}>
                    <Form.Group>
                      <Form.Control
                        as="select"
                        value={creator.position}
                        onChange={e => {
                          author[index].position = e.target.value;
                          set_data({ ...data, author });
                        }}>
                        {positions.map(position => (
                          <option key={position.name} value={position.name}>
                            {position.title.fa}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>
                  </Col>
                  {renderInputs(creator, index)}
                  {actions}
                </Row>
              );
            })}
          </>
        );
      };
    case "language":
      return ({ title, data, set_data }) => (
        <Row>
          <Col>
            <Form.Group>
              <Form.Label>{title.fa}</Form.Label>
              <Form.Control
                onChange={e => {
                  data.language = e.target.value;
                  set_data(data);
                }}
                as="select"
                defaultValue={data.language}>
                <option value="">انتخاب نشده</option>
                <option value="fa">فارسی</option>
                <option value="en">انگلیسی</option>
                <option value="ar">عربی</option>
              </Form.Control>
            </Form.Group>
          </Col>
        </Row>
      );

    case "issued":
    case "accessed":
      return ({ title, type = "year-month-day", data, set_data }) => {
        let issued = (data.issued || { "date-parts": [[""]] })[
          "date-parts"
        ][0][0];
        const parts = issued.split("-");

        let day = "",
          month = "",
          year = "";
        if (type === "year-month-day") {
          day = parts[2] || "";
        }
        if (type === "year-month" || "year-month-day") {
          month = parts[1] || "";
        }
        year = parts[0] || "";
        return (
          <>
            <Row>
              <Col
                style={{
                  marginBottom: 5,
                  direction: "rtl",
                  textAlign: "right",
                }}>
                {title.fa}
              </Col>
            </Row>
            <Row>
              {type === "year-month-day" ? (
                <Col>
                  <Form.Group>
                    <Form.Control
                      onChange={e => {
                        const obj = { ...data };
                        obj.issued = {
                          "date-parts": [
                            [`${year}-${month}-${e.target.value}`],
                          ],
                        };
                        set_data(obj);
                      }}
                      value={day}
                      type="number"
                      placeholder="روز"
                    />
                  </Form.Group>
                </Col>
              ) : null}
              {type === "year-month-day" || type === "year-month" ? (
                <Col>
                  <Form.Group>
                    <Form.Control
                      onChange={e => {
                        const obj = { ...data };
                        if (type === "year-month-day")
                          obj.issued = {
                            "date-parts": [
                              [`${year}-${e.target.value}-${day}`],
                            ],
                          };
                        if (type === "year-month")
                          obj.issued = {
                            "date-parts": [[`${year}-${e.target.value}`]],
                          };

                        set_data(obj);
                      }}
                      value={month}
                      type="number"
                      placeholder="ماه"
                    />
                  </Form.Group>
                </Col>
              ) : null}

              <Col>
                <Form.Group>
                  <Form.Control
                    onChange={e => {
                      const obj = { ...data };
                      if (type === "year-month-day")
                        obj.issued = {
                          "date-parts": [[`${e.target.value}-${month}-${day}`]],
                        };
                      if (type === "year-month")
                        obj.issued = {
                          "date-parts": [[`${e.target.value}-${month}`]],
                        };
                      if (type === "year")
                        obj.issued = {
                          "date-parts": [[`${e.target.value}`]],
                        };
                      set_data(obj);
                    }}
                    value={year}
                    placeholder="سال"
                    type="number"
                  />
                </Form.Group>
              </Col>
            </Row>
          </>
        );
      };

    default:
      return ({ title, data, set_data }) => (
        <Form.Group>
          <Form.Label>{title.fa}</Form.Label>
          <Form.Control
            onChange={e => {
              data[type] = e.target.value;
              set_data(data);
            }}
            defaultValue={data[type]}
            type="text"
          />
        </Form.Group>
      );
  }
};

export default Fields;
